import Utility from "./utility";

let PostDeletion = {};

PostDeletion.init = function () {
  const input = $("#reason");
  let inputVal = input.val() + "";

  // #region DMail Notification
  /** @type {HTMLInputElement} */
  const cBox = document.querySelector("input#send-dmail"),
    /** @type {HTMLSelectElement} */
    dMailTemplate = document.querySelector("select#del-dmail-template"),
    /** @type {HTMLElement} */
    message = document.querySelector("label[for=send-dmail] ~ .dtext-formatter"),
    /** @type {JQuery<HTMLTextAreaElement>} */
    dMailTextArea = $(message).children("textarea.dtext-formatter-input");
  function updateDMailActivation () {
    if (cBox.checked) {
      message.style.display = dMailTemplate.parentElement.style.display = "";
      dMailTextArea.removeAttr("disabled");
    } else {
      message.style.display = dMailTemplate.parentElement.style.display = "none";
      dMailTextArea.attr("disabled", "disabled");
    }
  }
  function updateReason () {
    let newVal = input.val()?.toString();
    dMailTextArea.val(
      Utility.blank(newVal)
        ? dMailTemplate.value
        : dMailTemplate.value.replaceAll("%REASON%", newVal),
    );
  }
  cBox.addEventListener("click", () => updateDMailActivation());
  dMailTemplate.addEventListener("change", () => updateReason());
  updateDMailActivation();
  updateReason();
  // #endregion DMail Notification

  // #region Delete Reason
  const buttons = $("a.delreason-button")
    .on("click", (event) => {
      event.stopPropagation();
      event.preventDefault();

      const $button = $(event.target);
      if (!$button.is("a")) return;

      const text = $button.data("processed");
      input.val((index, current) => {
        current = current.trim();
        if ($button.hasClass("enabled")) {
          return current
            .replace(text, "")
            .replace(/ \/ $|^ \/ /g, "") // trim leading and trailing slashes
            .replace(/( \/ ){2,}/g, " / "); // trim duplicate / leftover slashes
        } else return (current ? current + " / " : "") + text;
      });
      input.trigger("input");
    })
    .on("e621:refresh", (event) => {
      const $button = $(event.target);
      let text = $button.data("text");
      for (const buttonInput of $button.find("input[type=text]"))
        text = text.replace("%ID%", $(buttonInput).val());

      $button.data("processed", text);
      $button.toggleClass("enabled", inputVal.indexOf(text) >= 0);
    })
    .each((index, element) => {
      const $button = $(element);
      $button.find("input[type=text]").on("input", () => {
        $button.trigger("e621:refresh");
      });
    });
  buttons.trigger("e621:refresh");

  input.on("input", () => {
    inputVal = input.val() + "";
    buttons.trigger("e621:refresh");
    updateReason();
  });

  $("#delreason-clear").on("click", () => {
    input.val("").trigger("input");
  });
  // #endregion Delete Reason
};

$(function () {
  if ($("div#c-confirm-delete").length)
    Danbooru.PostDeletion.init();
});

export default PostDeletion;
